import BusinessDashboard from "./dashboard/BusinessDashboard";

export default function Dashboard() {
    return <BusinessDashboard />;
}
